import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { TextInput } from '@olxbr/ds-web'

const Content = styled(View)`
  position: relative;
  flex: 1 0;
`

class PasswordInput extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      showingPassword: props.visiblePassword,
    }
  }

  componentDidUpdate(prevProps) {
    const { visiblePassword } = this.props
    const { visiblePassword: previousVisiblePassword } = prevProps
    if (previousVisiblePassword !== visiblePassword) {
      this.setState({ showingPassword: visiblePassword })
    }
  }

  handleClick() {
    const { showingPassword } = this.state
    this.setState({ showingPassword: !showingPassword })
  }

  render() {
    const { props } = this
    const { showingPassword } = this.state
    return (
      <Content>
        <TextInput
          label={this.props.label}
          caption={this.props.caption}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          id="password-input"
          type={!showingPassword ? 'password' : 'text'}
          state={props.hasError ? 'error' : null}
          stateMessage={props.errorMsg}
          onFocus={this.props.onFocus}
          value={this.props.innerRef}
          {...this.props}
        />
      </Content>
    )
  }
}

PasswordInput.defaultProps = {
  hasError: false,
  visiblePassword: false,
}

PasswordInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  hasError: PropTypes.bool,
  value: PropTypes.string,
  visiblePassword: PropTypes.bool,
  onClickLink: PropTypes.func,
  onFocus: PropTypes.func,
  errorMsg: PropTypes.string,
  linkText: PropTypes.string,
}

const RefPasswordInput = (props, ref) => <PasswordInput {...props} innerRef={ref} />

export default RefPasswordInput
